import { z } from 'zod';

/** OpenAPI `CreateCurationV2Request.type` — 29CM 고정 GOODS, 무신사는 GOODS/SNAP2 */
export const CurationApiTypeSchema = z.enum(['GOODS', 'SNAP2']).describe('CurationApiTypeSchema');

export const CreateCurationsServiceRequestSchema = z
  .object({
    title: z.string(),
    description: z.string(),
    goodsNoList: z.array(z.string()),
    curationType: CurationApiTypeSchema,
  })
  .describe('CreateCurationsServiceRequestSchema');

export const CreateCurationsServiceResponseSchema = z
  .object({
    success: z.boolean(),
    curationId: z.string(),
  })
  .describe('CreateCurationsServiceResponseSchema');

export type CreateCurationsServiceRequest = z.infer<typeof CreateCurationsServiceRequestSchema>;
export type CreateCurationsServiceResponse = z.infer<typeof CreateCurationsServiceResponseSchema>;
